import { BalloonIcon, CircleDotIcon, SeniorIcon, UserIcon, VeteranIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";

const icons = [
    { name: /adult/i, icon: UserIcon },
    { name: /veteran/i, icon: VeteranIcon },
    { name: /senior/i, icon: SeniorIcon },
    { name: /child/i, icon: BalloonIcon },
];

const getIcon = (name: string) => {
    return icons.find((icon) => icon.name.test(name))?.icon ?? CircleDotIcon;
};

interface DemographicIconProps {
    name: string;
    className?: string;
    size?: string;
}

/**
 * Guesses demographic icon based on the name.
 */
export const DemographicIcon = ({ name, className, size, ...rest }: DemographicIconProps) => {
    const Icon = getIcon(name);
    return <Icon className={clsx("ui-demographic-icon", className)} size={size} {...rest} />;
};
